<template>
  <FormGroup :error="touched && !valid">
    <JobScheduleEditor
      v-model="copy"
      :timezone="field.timezone"
      :disabled="readOnly"
      @focus="select"
      @blur="unselect"
    />

    <template #error>
      <span v-show="touched && !valid">{{ error }}</span>
    </template>
  </FormGroup>
</template>

<script>
import rowEditField from "@baserow/modules/database/mixins/rowEditField";
import rowEditFieldInput from "@baserow/modules/database/mixins/rowEditFieldInput";
import JobScheduleEditor from "@peninsula/components/JobScheduleEditor";

export default {
  name: "JobScheduleRowEditField",
  components: { JobScheduleEditor },
  mixins: [rowEditField, rowEditFieldInput],
};
</script>
